module.exports = __webpack_public_path__ + "h5/static/img/ssig.801ab38d.png";